export const FORMAT_CATEGORY_IDS_ARRAY = [71, 72, 73]
